import { Feedback, FeedbackContentType } from 'v2/core/entities/feedback';

export const isEmptyAudioSourceFeedback = (feedback: Feedback): boolean => {
  return (
    feedback.content.type === FeedbackContentType.Audio &&
    !feedback.content.audioFile
  );
};
